import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useAccount');

    return {
        UPDATE_USER_SUCCESS: t('updateUserSuccess')
    };
};

export default useTranslation;
